import { ActionTree, Action } from 'vuex';
import { RootState } from '@/store/types/root.state';
import { CVState } from '@/store/types/CV.state';
import db from "@/firebase";
import Tool from '@/models/tool';
import Job from '@/models/job';
import Study from '@/models/study';
import Language from '@/models/language';
import Honor from '@/models/honor';

export const actions: ActionTree<CVState, RootState> = {
    async fetchToolkit({ commit, state }) {
        db.collection('CV-toolkit').onSnapshot((data) => {
            const tools: Tool[] = [];
            data.docs.map((item, i) => {
                tools[i] = new Tool();
                tools[i].name = item.data().name;
                tools[i].type = item.data().type;
                tools[i].level = item.data().level;
            });
            tools.sort((a, b) => b.level - a.level);
            commit('setToolkit', tools);
        });
    },
    async fetchJobs({ commit, state }) {
        db.collection('CV-jobs').onSnapshot((data) => {
            const jobs: Job[] = [];
            data.docs.map((item, i) => {
                jobs[i] = new Job();
                jobs[i].name = item.data().name;
                jobs[i].description = item.data().description;
                jobs[i].startYear = item.data().startYear;
                jobs[i].endYear = item.data().endYear;
                jobs[i].workingHere = item.data().workingHere;
                jobs[i].location = item.data().location;
                jobs[i].posts = item.data().posts;
            });
            jobs.sort((a, b) => b.startYear - a.startYear);
            commit('setJobs', jobs);
        });
    },
    async fetchStudies({ commit, state }) {
        db.collection('CV-studies').onSnapshot((data) => {
            const studies: Study[] = [];
            data.docs.map((item, i) => {
                studies[i] = new Study();
                studies[i].name = item.data().name;
                studies[i].institution = item.data().institution;
                studies[i].startYear = item.data().startYear;
                studies[i].endYear = item.data().endYear;
                studies[i].studyingHere = item.data().studyingHere;
                studies[i].notFinished = item.data().notFinished;
            });
            studies.sort((a, b) => b.startYear - a.startYear);
            commit('setStudies', studies);
        });
    },
    async fetchHonors({ commit, state }) {
        db.collection('CV-honors').onSnapshot((data) => {
            const honors: Honor[] = [];
            data.docs.map((item, i) => {
                honors[i] = new Honor();
                honors[i].name = item.data().name;
                honors[i].year = item.data().year;
            });
            commit('setHonors', honors);
        });
    },
    async fetchLanguages({ commit, state }) {
        db.collection('CV-languages').onSnapshot((data) => {
            const languages: Language[] = [];
            data.docs.map((item, i) => {
                languages[i] = new Language();
                languages[i].name = item.data().name;
                languages[i].level = item.data().level;
                languages[i].importance = item.data().importance;
            });
            languages.sort((a, b) => a.importance - b.importance);
            commit('setLanguages', languages);
        });
    },

    async fetchData({ commit, dispatch }) {
        dispatch('fetchToolkit');
        dispatch('fetchJobs');
        dispatch('fetchHonors');
        dispatch('fetchStudies');
        dispatch('fetchLanguages');
    },
}